export const PER_PAGE = 5;

export const formatDate = (dateString) => {
    if (!dateString) {
        return '-';
    }
    const date = new Date(dateString);
    if (isNaN(date.getTime())) {
        return '-';
    }
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    return `${day}-${month}`;
};

export const matchesFilters = (row, filters) => {
    if (filters.customerId && String(row.customer_id) !== String(filters.customerId)) {
        return false;
    }
    if (filters.jobTypeId && String(row.job_type_id) !== String(filters.jobTypeId)) {
        return false;
    }
    return true;
};
